// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2q2EU","header":"MessagesList_header__31462","chat":"MessagesList_chat__34x4g"};